import tinycolor from 'tinycolor2'

import { EMPTY_OBJECT } from '../../../constants/common'
import {
  EVENT_NAME_MOUSE_MOVE,
  EVENT_NAME_MOUSE_UP,
} from '../../../constants/event'
import { COLOR_PICKER_DEFAULT_HEX } from '../ColorPicker.constants'
import { normalizeHexColor } from '../ColorPickerField'

export function getCommitHex(value) {
  const normalized = normalizeHexColor(value)

  return normalized &&
    String(normalized).trim() &&
    tinycolor(normalized).isValid()
    ? normalized
    : COLOR_PICKER_DEFAULT_HEX
}

export function normalizeColorMap(value) {
  return Object.entries(value || EMPTY_OBJECT).reduce((acc, [key, item]) => {
    const color = tinycolor(item?.color || '#000000')

    acc[key] = {
      ...item,
      color: color.isValid() ? color.toHexString().toUpperCase() : '#000000',
    }

    return acc
  }, {})
}

export function hexToHsv(hex) {
  const hsv = tinycolor(hex).toHsv()

  return {
    h: Number.isFinite(hsv.h) ? hsv.h : 0,
    s: Number.isFinite(hsv.s) ? hsv.s : 0,
    v: Number.isFinite(hsv.v) ? hsv.v : 0,
  }
}

export function hsvToHex(hsv) {
  return tinycolor({
    h: hsv.h,
    s: hsv.s * 100,
    v: hsv.v * 100,
  })
    .toHexString()
    .toUpperCase()
}

export function getSvSquareBackground(hue) {
  return `hsl(${hue}, 100%, 50%)`
}

export function getSvPointerPosition(hsv) {
  return {
    left: `${hsv.s * 100}%`,
    top: `${(1 - hsv.v) * 100}%`,
  }
}

export function getHuePointerPosition(hue) {
  return {
    left: `${(hue / 360) * 100}%`,
  }
}

export function bindDrag(moveHandler) {
  function handleMouseMove(event) {
    moveHandler(event)
  }

  function handleMouseUp() {
    window.removeEventListener(EVENT_NAME_MOUSE_MOVE, handleMouseMove)
    window.removeEventListener(EVENT_NAME_MOUSE_UP, handleMouseUp)
  }

  window.addEventListener(EVENT_NAME_MOUSE_MOVE, handleMouseMove)
  window.addEventListener(EVENT_NAME_MOUSE_UP, handleMouseUp)
}

export function getRgbFromHex(hex) {
  const rgb = tinycolor(hex).toRgb()

  return {
    b: rgb.b,
    g: rgb.g,
    r: rgb.r,
  }
}
